import extractVideoIdFromYTUrl from '@/helpers/utils/extractVideoIdFromYTUrl'

function composeEmbeddedYoutubeVideoUrl(id?: string) {
  if (!id) return
  return `https://www.youtube-nocookie.com/embed/${id}`
}

function getEmbeddableVideoUrl(url: string) {
  return composeEmbeddedYoutubeVideoUrl(extractVideoIdFromYTUrl(url))
}

export default getEmbeddableVideoUrl
